export const splitFullName = (fullName) => {
    const [firstName, ...rest] = fullName.trim().split(/\s+/); // Use regex to split by one or more spaces
    const lastName = rest.length ? rest.join(' ') : '';
    return { firstName, lastName };
};
